import { useTranslation, Trans } from "react-i18next";
const CustomersCounter=()=>{
    const { t } = useTranslation();
    return <div className="customers-counter">
        <div className="container">
            <div className="row justify-content-center gy-4">
                <div className="col-6 col-sm-6 col-md-3">
                    <div className="counter text-center">
                        <h2 className="mb-1 num-counter">10,000</h2>
                        <span className="fs-5 text-capitalize">{t('happy customers')}</span>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-md-3">
                    <div className="counter text-center">
                        <h2 className="mb-1 num-counter">1000</h2>
                        <span className="fs-5 text-capitalize">{t('partner')}</span>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-md-3">
                    <div className="counter text-center">
                        <h2 className="mb-1 num-counter">900</h2>
                        <span className="fs-5 text-capitalize">{t('skin treatment')}</span>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-md-3">
                    <div className="counter text-center">
                        <h2 className="mb-1 num-counter">100</h2>
                        <span className="fs-5 text-capitalize">{t('awards')}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
export default CustomersCounter;